module.exports = __webpack_public_path__ + "static/media/panorama3.ab3361e3.png";